import { watch } from 'vue';
import useContent from '@/composables/useContent';
import useActions from '@/composables/useActions';
import types from '@/actions/types';

export default function useWebsitePlugin() {
  let shouldResetContent = false;
  const { resetCurrentContent, contentPromiseResolve } = useContent();
  const { currentAction } = useActions();

  async function handleClose() {
    shouldResetContent = currentAction.value.name === types.SAY;
    currentAction.value.stop();
    if (contentPromiseResolve.value) {
      contentPromiseResolve.value(); // finish current bg video
    }
  }

  watch(currentAction, (action) => {
    if (shouldResetContent) {
      action.stop();
      resetCurrentContent();
    }
  });

  return {
    handleClose,
  };
}
